export default "__VITE_ASSET__J0kI5j3Y__"